<div *ngIf="props.label" class="d-flex align-items-center">
  <ng-template #fieldComponent></ng-template>
</div>
